import React, { useState, useEffect } from "react";
import { Spinner, Badge, Accordion, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { getLocale, setLocale } from "./i18nRefs.jsx";
import { dict } from "./i18n";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import { incidenthistory } from "./api";
import Header from "./Header.js";
import Footer from "./Footer.js";
import moment from "moment";
import { FaExclamationTriangle } from 'react-icons/fa'

import awsExports from "./aws-exports";
Amplify.configure(awsExports);

export default function PublicWarnings() {
  let [historyData, setHistoryData] = useState([]);
  const [locale, setLocalLocale] = useState(getLocale());
  const [i18n, seti18n] = useState(dict[getLocale()]);
  const [loaded, setLoaded] = useState(false);

  const prop66WarningText = (startDateTime, endDateTime) => {
    let prop66Text = i18n.UNABLE_TO_DISPLAY_INFORMATION_AT_THIS_TIME;

    try {
      // See http://jira.sonomatech.com/browse/SCG-14 for more info on the legally-required verbiage
      const startDate = moment(startDateTime * 1000).format("L"); // 06/26/2022
      const startTime = moment(startDateTime * 1000).format("LT"); // 5:52 PM

      if (endDateTime) {
        const endDate = moment(endDateTime * 1000).format("L"); // 06/26/2022
        const endTime = moment(endDateTime * 1000).format("LT"); // 5:52 PM

        prop66Text = i18n.WEBSITE_WARNING_EXCEEDENCE_END.replace(
          "[STARTDATE]",
          startDate
        )
          .replace("[STARTTIME]", startTime)
          .replace("[ENDDATE]", endDate)
          .replace("[ENDTIME]", endTime);
      } else {
        prop66Text = i18n.WEBSITE_WARNING_EXCEEDENCE_START.replace(
          "[STARTDATE]",
          startDate
        ).replace("[STARTTIME]", startTime);
      }
    } catch (e) {
      console.warn("error generating text", e);
    } finally {
      return prop66Text;
    }
  };


  const p66WarningEventsAsAccordionItems = (historyData) => {
    if (Array.isArray(historyData) && historyData.length > 0) {

      return historyData.map((val, key) => {
        return (
          <Accordion style={{ width: "100%" }}>
            <Accordion.Item eventKey={key}>
              <Accordion.Header>
                <div style={styles.accordionHeader}>
                  <div>
                    {moment(val.started_at * 1000).format("LLL")}
                  </div>
                  <div style={{ alignSelf: "right" }}>
                    {val.ended_at ? (
                      <Badge bg="success">{i18n.EVENT_ENDED}</Badge>
                    ) :
                      <Badge bg="warning">{i18n.ACTIVE_EVENT}</Badge>
                    }
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <h5> <FaExclamationTriangle /> {i18n.PROP_66_WARNING}
                </h5>
                <p>
                  {prop66WarningText(val.started_at, val.ended_at)}
                </p>
                <p>
                  {i18n.FOR_MORE_INFO_GO_TO}{" "}
                  <a
                    href="https://www.p65warnings.ca.gov"
                    target="_blank"
                  >
                    https://www.p65warnings.ca.gov
                  </a>
                  .
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        );
      })
    } else {
      return (
        <Alert variant="success">
          {i18n.NO_WARNINGS_ISSUED_IN_90_DAYS}
        </Alert>
      )
    }

  }

  useEffect(() => {
    let mounted = true;
    try {
      incidenthistory().then((items) => {
        if (mounted) {
          items.sort((a, b) => (a.started_at < b.started_at ? 1 : -1));
          setHistoryData(items);
          setLoaded(true);
        }
      });
    } catch (e) {
      console.error("oh noes", e);
    }
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main>
      <div style={styles.header}>
        <Header activeKey={"warnings"} />
      </div>

      <div id="body" className="text-center align-middle" style={styles.body}>

        <div
          style={{ paddingBottom: 20 }}
        >
          <h3>{i18n.HEADER_TITLE}</h3>
        </div>

        {!loaded && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Spinner
              animation="border"
              size="lg"
              role="status"
              variant="primary"
            />
          </div>
        )}

        {loaded && (
          <div style={{ width: "100%", marginTop: 10 }}>
            {
              <div>
                {Array.isArray(historyData) && historyData.length > 0 &&
                  <h3>{i18n.ISSUED_WARNINGS}</h3>
                }
                <div style={{ marginTop: 20 }}>
                  {p66WarningEventsAsAccordionItems(historyData)}
                </div>
              </div>
            }
          </div>
        )}
      </div>

      <div style={styles.footer}>
        <Footer />
      </div>
    </main>
  );
}

const styles = {
  header: {
    minHeight: "10vh",
  },
  body: {
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  footer: {
    borderTop: "1px solid #eee",
  },
  accordionHeader: {
    width: "96%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
  },
};
